export const SAME_PROVIDER = 'sameProvider';
export const DIFFERENT_PROVIDER = 'differentProvider';
export const PATIENT_DETAILS = 'patientDetails';
export const APPOINTMENT_DETAILS = 'appointmentDetails';